/**
 * Created by phatbass on 2/9/16.
 */

angular.module('far.educations')
    .controller('EducationGalleryEditController', function (educationGalleryForm, $http, $log, showModalMessage) {
        var errorMessages = [];
        
        var vm = {
            progress: true,
            submitted: false,
            fields: educationGalleryForm,
            form: {
                id: null,
                slides_files: []
            },
            construct: function (event) {
                vm.form.id = event;

                $http.get(Routing.generate('api_event_get_event_gallery_edit', {event: vm.form.id}))
                    .then(function (response) {
                        angular.forEach(response.data, function (image) {
                            vm.form.slides_files.push(image);
                        });

                        vm.progress = false;
                    }, function errorCallback(response) {
                        $log.error(response);
                        showModalMessage('Невозможно загрузить галерею.');

                        vm.progress = false;
                    });

                vm.fields.$fields.slides_files.uploader.onSuccessItem = function (item, response) {
                    vm.form.slides_files.push(response);
                };
                vm.fields.$fields.slides_files.uploader.onWhenAddingFileFailed = function(item, filter) {
                    var message = filter.message ? filter.message : 'Невозможно загрузить файл на сервер';
                    
                    if (errorMessages.indexOf(message) == -1) {
                        errorMessages.push(message); 
                    }
                };
                vm.fields.$fields.slides_files.uploader.onErrorItem = function() {
                    var message = 'Невозможно загрузить файл на сервер';

                    if (errorMessages.indexOf(message) == -1) {
                        errorMessages.push(message);
                    }
                };
                vm.fields.$fields.slides_files.uploader.onCompleteAll = function() {
                    if (errorMessages.length > 0) {
                        showModalMessage(errorMessages.slice(0), 'Некоторые файлы не были загружены, т.к.:');
                        errorMessages = [];
                    }
                };
            },
            submit: function () {
                if (vm.submitted) {
                    return false;
                }

                vm.submitted = true;

                vm.form.slides_files = vm.form.slides_files.map(function (slide, index) {
                    slide.sort = index + 1;
                    return slide;
                });

                $http.put(Routing.generate('api_event_put_event_gallery', {event: vm.form.id}), vm.form)
                    .then(function (response) {
                        document.location.href=Routing.generate('event_gallery', {id: response.data.id});
                    }, function errorCallback(response) {
                        $log.error(response);

                        showModalMessage('Невозможно сохранить галерею.');

                        vm.submitted = true;
                    });
            }
        };

        return vm;
    });
